module.exports = __webpack_public_path__ + "static/media/dnerhs.6d38ee5f.jpg";